import type { AdminActorProfileOptions } from './adminActorContext'
import {
  actorCanPickAnyCompanyGroup,
  actorUsesOwnCompanyGroupScope,
  resolveEffectiveCompanyGroupId,
} from './adminActorContext'

export type OperatorCreateScopeInput = {
  currentUser: Record<string, unknown> | null | undefined
  actorOpts?: AdminActorProfileOptions
  assignTarget: 'superadmin' | 'company'
  selectedCompanyId: number | null
}

export type OperatorCreateScopeResult =
  | { ok: true; companyGroupAdminId: number | null; companyAdminId: null }
  | { ok: false; reason: 'scope' | 'missing-cga' | 'pick-company' }

/** Resolves tenant binding for Operator create from authenticated actor (not browser sub-company). */
export function resolveOperatorCreateScope(input: OperatorCreateScopeInput): OperatorCreateScopeResult {
  const { currentUser, actorOpts, assignTarget, selectedCompanyId } = input
  const actorCanPickCompanyGroup = actorCanPickAnyCompanyGroup(currentUser, actorOpts)
  const actorOwnCompanyGroupScope = actorUsesOwnCompanyGroupScope(currentUser, actorOpts)
  const myCompanyGroupAdminId = resolveEffectiveCompanyGroupId(currentUser)

  if (actorCanPickCompanyGroup) {
    if (assignTarget === 'superadmin') {
      return { ok: true, companyGroupAdminId: null, companyAdminId: null }
    }
    if (selectedCompanyId == null) {
      return { ok: false, reason: 'pick-company' }
    }
    return {
      ok: true,
      companyGroupAdminId: Number(selectedCompanyId),
      companyAdminId: null,
    }
  }

  if (actorOwnCompanyGroupScope) {
    const companyGroupAdminId =
      myCompanyGroupAdminId != null ? Number(myCompanyGroupAdminId) : null
    if (companyGroupAdminId == null) {
      return { ok: false, reason: 'missing-cga' }
    }
    return { ok: true, companyGroupAdminId, companyAdminId: null }
  }

  return { ok: false, reason: 'scope' }
}
